import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import LandingPage from './pages/LandingPage';
import ErrorPage from './pages/ErrorPage';
import Footer from './components/Landing/Footer';
import ScrollToTop from './components/common/ScrollToTop';

function App() {
  const showLayout = location.pathname === '/';
  return (
    <>
      {showLayout && <Navbar />}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
      {showLayout && <Footer />}
    </>
  );
}

export default App;
